import { Group } from "@mantine/core";
import { Outlet } from "react-router-dom";
import LeftLinks from "./LeftLinks";

const SendersPageWrapper = () => {
  return (
    <Group wrap="nowrap" flex={1} h={"100%"} gap={0} align="start">
      <LeftLinks />

      <Outlet />
    </Group>
  );
};

export default SendersPageWrapper;
